import angular from 'angular';
import PriceFilterDirective from './price-filter.directive';

let PriceFilterModule = angular.module('catalog.productsList.priceFilter', [])
  .directive('priceFilter', PriceFilterDirective);

export default PriceFilterModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/products-list/price-filter/price-filter.js
 **/